import { render, staticRenderFns } from "./Exam.vue?vue&type=template&id=c228e75c&scoped=true&"
import script from "./Exam.vue?vue&type=script&lang=js&"
export * from "./Exam.vue?vue&type=script&lang=js&"
import style0 from "./Exam.vue?vue&type=style&index=0&id=c228e75c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c228e75c",
  null
  
)

component.options.__file = "Exam.vue"
export default component.exports